import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MonacoEditor = _resolveComponent("MonacoEditor")!
  const _component_TestFrame = _resolveComponent("TestFrame")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["h-full", { select: _ctx.isHandlingTestFrame }])
  }, [
    _createElementVNode("div", {
      class: "w-full relative pt-2",
      style: _normalizeStyle(`height: calc(100% - ${_ctx.testFrameHeight}px)`)
    }, [
      _createVNode(_component_MonacoEditor, {
        id: "editor",
        class: "min-h-0 mr-1 h-full w-full",
        keySubmmit: _ctx.keySubmmit,
        keyTest: _ctx.keyTest,
        shortcutKey: _ctx.shortcutKey,
        sideMenuWidth: _ctx.sideMenuWidth,
        style: {"user-select":"none"}
      }, null, 8, ["keySubmmit", "keyTest", "shortcutKey", "sideMenuWidth"])
    ], 4),
    _createElementVNode("div", {
      class: "w-full z-10 absolute border-t bottom-0 flex flex-col border-gray-300 dark:border-dark-200",
      style: _normalizeStyle(`height: ${_ctx.testFrameHeight}px`)
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["panel-cursor-area w-full py-1 h-2 border-b border-gray-300 hover:bg-primary dark:border-dark-200 dark:hover:bg-primary", {
          'bg-primary ': _ctx.isHandlingTestFrame
        }]),
        onMousedown: _cache[0] || (_cache[0] = ($event: any) => (_ctx.mouseDownEditorBottomSlideBar()))
      }, null, 34),
      _createVNode(_component_TestFrame, { onOpenReviewAlertModal: _ctx.openReviewAlertModal }, null, 8, ["onOpenReviewAlertModal"])
    ], 4)
  ], 2))
}